import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { polyfill } from 'pluralPolyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import { MuiThemeProvider, createTheme, StylesProvider, createGenerateClassName } from '@material-ui/core/styles';
import { ApolloProvider } from 'react-apollo';
import { Rehydrated } from 'aws-appsync-react'; // this needs to also be installed when working with React
import { SnackbarProvider } from 'notistack';

import App from 'pages/App/App';
import ThreeppAlert from 'components/common/Alert/Alert';
import ThreeppErrorBoundary from 'components/threepp/ErrorBoundary/ErrorBoundary';
import * as serviceWorker from './serviceWorker';
import i18n from './i18n';
import { aWSAppSyncClient } from './apolloClient';

import '@fontsource/lato';
import './index.scss';

// Material-UI Theme colors. Need to be moved to SCSS files.
const theme = createTheme({
  overrides: {
    MuiTooltip: {
      tooltip: {
        fontSize: '.8rem'
      }
    }
  },
  typography: {
    fontFamily: [
      '"Lato"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(',')
  },
  palette: {
    primary: {
      main: '#176DC2'
    },
    secondary: {
      main: '#d62626'
    },
    icon: {
      iconColor: '#616161',
      iconHoverColor: 'rgba(23, 109, 194, 0.15)'
    },
    linkColor: '#176DC2',
    textColor: '#212121',
    outlineColor: '#176DC2'
  },
  whitespace: {
    least: '0.25rem',
    less: '0.5rem',
    base: '1rem',
    more: '2rem',
    most: '3.5rem'
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      mobile: 834,
      md: 960,
      lg: 1281,
      xl: 1860
    }
  },
  sizes: {
    modalMaxWidth: '420px'
  }
});

// Provide a unique class name prefix for makeStyles() classnames to avoid conflict with other libraries
const classNameBase = 'Engage';
const classNameSeed = 'AE';

const generateClassName = createGenerateClassName({
  productionPrefix: `${classNameBase}-`,
  seed: classNameSeed
});

polyfill(i18n.language);

ReactDOM.render(
  <ApolloProvider client={aWSAppSyncClient}>
    <I18nextProvider i18n={i18n}>
      <MuiThemeProvider theme={theme}>
        <StylesProvider generateClassName={generateClassName}>
          <SnackbarProvider maxSnack={1} hideIconVariant>
            <ThreeppAlert />
          </SnackbarProvider>
          <ThreeppErrorBoundary>
            <Rehydrated>
              <App />
            </Rehydrated>
          </ThreeppErrorBoundary>
        </StylesProvider>
      </MuiThemeProvider>
    </I18nextProvider>
  </ApolloProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
